import { render, staticRenderFns } from "./ScoreCharts.vue?vue&type=template&id=357a6b3c&scoped=true"
import script from "./ScoreCharts.vue?vue&type=script&lang=js"
export * from "./ScoreCharts.vue?vue&type=script&lang=js"
import style0 from "./ScoreCharts.vue?vue&type=style&index=0&id=357a6b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a6b3c",
  null
  
)

export default component.exports